import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#627EEA"
    />
    <path
      d="M41.2451 10V32.175L59.9876 40.55L41.2451 10Z"
      fill="white"
      fill-opacity="0.602"
    />
    <path d="M41.245 10L22.5 40.55L41.245 32.175V10Z" fill="white" />
    <path
      d="M41.2451 54.92V69.9875L60.0001 44.04L41.2451 54.92Z"
      fill="white"
      fill-opacity="0.602"
    />
    <path d="M41.245 69.9875V54.9175L22.5 44.04L41.245 69.9875Z" fill="white" />
    <path
      d="M41.2451 51.4326L59.9876 40.5501L41.2451 32.1801V51.4326Z"
      fill="white"
      fill-opacity="0.2"
    />
    <path
      d="M22.5 40.5501L41.245 51.4326V32.1801L22.5 40.5501Z"
      fill="white"
      fill-opacity="0.602"
    />
  </svg>
)
